/* ============================================================
   PRIMEX — assets/primex-gallery-fit.js  (v1.0)

   Keeps every photo in the main gallery exactly inside its frame.

   Problem: Swiper measures its container with element.clientWidth, which is
   rounded to a WHOLE pixel, while the CSS lays the slides out at the real,
   fractional width (e.g. 712.4px). Swiper then moves the track by 712px per
   photo instead of 712.4px, and the error grows with every slide: by the
   last photo the previous one peeks in a few pixels on the left.

   Fix: hand Swiper the real fractional width (its documented `width`
   parameter) and keep it in sync on resize / tab switch.

   - Does not create or replace any slider; it only adjusts the existing
     one found at  .pxg-main.swiper  (element.swiper).
   - Never touches the thumbnails, the Konfiguration tab or any other file.
   - If no slider is found, it does nothing.
   ============================================================ */
(function () {
  'use strict';
  if (window.__pxgFitLoaded) return;
  window.__pxgFitLoaded = true;

  var MAIN = '.pxg-main.swiper';
  var watched = typeof WeakSet === 'function' ? new WeakSet() : null;

  function trueWidth(el) {
    var cs = window.getComputedStyle(el);
    var w = el.getBoundingClientRect().width -
      (parseFloat(cs.borderLeftWidth) || 0) - (parseFloat(cs.borderRightWidth) || 0);
    return w;
  }

  function fit(el) {
    var sw = el && el.swiper;
    if (!sw || sw.destroyed || !sw.params) return;
    var w = trueWidth(el);
    if (!(w > 0)) return;                      // hidden (other tab): keep the last value
    if (Math.abs((sw.params.width || 0) - w) > 0.01) {
      sw.params.width = w;                     // Swiper subtracts its own padding
      sw.update();                             // re-measures and keeps the current slide
    }
  }

  function watch(el) {
    var sw = el.swiper;
    if (!sw || sw.destroyed) return;
    if (watched) {
      if (watched.has(sw)) { fit(el); return; }
      watched.add(sw);
    }
    if (typeof ResizeObserver === 'function') {
      new ResizeObserver(function () { fit(el); }).observe(el);
    }
    fit(el);
  }

  function scan() {
    var list = document.querySelectorAll(MAIN);
    for (var i = 0; i < list.length; i++) watch(list[i]);
  }

  // The gallery script may create the slider after this file runs: look for it
  // for a few seconds, and again whenever a class changes inside the gallery
  // (Swiper adds "swiper-initialized" when it starts).
  var tries = 0;
  var timer = setInterval(function () {
    scan();
    if (++tries > 40) clearInterval(timer);    // ~12 s
  }, 300);

  function observeFrames() {
    var frames = document.querySelectorAll('.pxg');
    for (var i = 0; i < frames.length; i++) {
      if (frames[i].__pxgFitObs) continue;
      frames[i].__pxgFitObs = true;
      new MutationObserver(scan).observe(frames[i], {
        subtree: true, attributes: true, attributeFilter: ['class', 'hidden']
      });
    }
  }

  function start() { observeFrames(); scan(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  window.addEventListener('load', scan);
  window.addEventListener('resize', scan);
  window.addEventListener('orientationchange', scan);
})();